<template>
  <div class="footerText">{{footerText}} · <a class="footerPolicy" style="color: #6E6E6E;" href="#" @click="showModal=true">{{$t('footer.privacy_policy')}}</a>
    <va-modal
      :value="showModal"
      ref="privacyPolicyModal"
      id="privacyPolicyModal"
      size="large"
      @cancel="onCancel"
      :okClass="'none'"
      :cancelClass="'none'">
      <iframe style="width: 100%; height: 100%; display: flex; position: absolute;" :src="currentLanguage === 'pt' ? 'https://evollu.com/legal/platform/pt/privacy_policy.html' : 'https://evollu.com/legal/platform/en/privacy_policy.html'" frameborder="0"></iframe>
    </va-modal>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'app-footer',
  data () {
    return {
      showModal: false
    }
  },
  methods: {
    onCancel: function () {
      this.showModal = false
    },
  },
  computed: {
    footerText: function () {
      return `Copyright © ${moment().format('YYYY')} All Rights Reserved by Evollu`
    },
    currentLanguage: function () {
      return this.$i18n.locale()
    }
  }
}
</script>

<style lang="scss">
.footerText {
  font-size: 0.8rem;
}

.footerPolicy {
  &:hover {
    text-decoration: underline;
  }
}

#privacyPolicyModal {
  .va-modal__actions {
    display: none;
  }
  .va-modal__inner {
    padding: 0 !important;
    min-height: 80vh;
  }
}
</style>
